export default {
  title: 'Calculator de venituri din taxa de serviciu',
  description:
    'Estimează câți bani generează taxa de serviciu în fiecare lună. Valorile se actualizează pe măsură ce scrii.',
  authoritative:
    'Procentul și taxa maximă de mai jos sunt setările care vor fi aplicate. Valoarea medie a comenzii și GMV-ul lunar sunt doar estimări.',
  off_notice:
    'Taxa de serviciu este dezactivată la acest restaurant, deci nu generează încă venituri. Salvați o taxă mai mare de 0 pentru a o activa.',
  fields: {
    recommended: 'Recomandat: {{value}}',
    aov: {
      label: 'Valoarea medie a comenzii',
      help: 'Dimensiunea tipică a coșului pe sistemul tău de comenzi online.',
      placeholder: 'ex. 32,50',
    },
    percentage: {
      label: 'Procentul taxei de serviciu',
      help: 'Între {{min}}% și {{max}}%.',
    },
    max_amount: {
      label: 'Taxa maximă per comandă',
      help: '{{max}} este maximul platformei.',
      below_min: 'Taxa maximă trebuie să fie de cel puțin {{min}}.',
    },
    monthly_gmv: {
      label: 'GMV lunar',
      help: 'Valoarea totală a comenzilor procesate lunar.',
      placeholder: 'ex. 85000',
    },
  },
  outputs: {
    partner_revenue: 'Venitul tău lunar estimat',
    approximate: 'Cifră aproximativă bazată pe valorile de mai sus — venitul real poate varia.',
    estimate_inputs: 'Bazat pe valoarea comenzii și GMV-ul estimate — venitul real poate varia.',
    share: 'Aceasta este cota ta de {{share}}% din totalul taxei de serviciu colectate.',
    total_collected: 'Totalul taxei de serviciu colectate de la clienți la finalizarea comenzii',
    total_collected_note: '— plătită de clienți, nu venit suplimentar peste cifra de mai sus.',
    effective_rate: 'Rata efectivă a taxei pentru toate comenzile',
  },
};
